export default {"src":"/_next/static/media/square-dark.5388ffe0.svg","height":386,"width":386,"blurWidth":0,"blurHeight":0};